import { render, staticRenderFns } from "./LicenseAddEditDialog.vue?vue&type=template&id=5965226a&scoped=true&"
import script from "./LicenseAddEditDialog.vue?vue&type=script&lang=ts&"
export * from "./LicenseAddEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseAddEditDialog.vue?vue&type=style&index=0&id=5965226a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5965226a",
  null
  
)

export default component.exports